<div class="input-grid-gaps grid-6col container">
    <div class="fr-3 flex gap align-items-center">
        <p-fileupload #fu mode="basic" name="myFile[]" auto="false" [customUpload]="true"
            [chooseLabel]="'sickNotes.buttons.addCertificate' | translate"
            chooseIcon="pi pi-upload" accept=".pfx">
        </p-fileupload>
        @if (fu.files.length) {
            <app-button icon="pi pi-times" (clickEvent)="fu.clear()"></app-button>
        }
    </div>

    <div class="fr-3">
        <app-password-input [form]="form" id="passphrase" label="inputs.password"></app-password-input>
    </div>
</div>
